import React from 'react';
import { HelmetProvider } from 'react-helmet-async';

import MapPageHelmet from './components/MapPageHelmet';
import Map from './Map';
import Lmarkers from './components/layers/Lmarkers';
import LactiveMarkers from './components/layers/LactiveMarkers';
import Header from './components/Header';
import LeftBlock from './components/LeftBlock';
import PopupDefault from './components/popups/PopupDefault';

const MapApp = () => {
  return (
    <HelmetProvider>
      <MapPageHelmet />
      <Header/>
      <Map/>
      <Lmarkers/>
      <LactiveMarkers/>
      <LeftBlock/>
      <PopupDefault/>
    </HelmetProvider>
  )
}

export default MapApp;
